// 工具函数文件
import axios from 'axios';
import { createHashHistory } from 'history';
import momentTimeZone from 'moment-timezone';
import * as xlsx from 'xlsx'
import { MobxObjectsManager } from '../page/mobx-objs/mobx-manager';
import MainPageState from '../page/main/main-page-states';

const mainPageData = MobxObjectsManager.get(MainPageState);

// $ 获取url中的参数
export function getUrlParam(
  keyName?: string,
  url?: string,
): string | undefined {
  try {
    const reg = new RegExp('(^|&)' + keyName + '=([^&]*)(&|$)', 'i');
    let r: RegExpMatchArray | null = null;
    if (url && url.split('?').length > 1) {
      r = url.split('?')[1].match(reg);
    } else if (createHashHistory()) {
      r = createHashHistory().location.search.substring(1).match(reg);
    }
    if (r) {
      const text = decodeURI(r[2]);
      // 分析文本
      // text = objDecryption(text);
      return text;
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
}

// $ 生成文件
export function generateText(
  fileName: string,
  content: string,
  type?: string,
): void {
  /**
   * 1.创建bold格式
   * 2.创建FileReader构造对象
   * 3.创建a标签，进行下载
   */
  const blob = new Blob([content], {
    type: type || 'application/octet-stream;charset=utf-8',
  });
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onload = function (evt) {
    const element = document.createElement('a');
    element.download = fileName;
    element.href = (evt.target?.result || '') as string;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };
}
// $ 获取到text文本
export function getTextTemplate(
  params: {
    host: string;
    port: string;
    city: string;
    nickname: string;
    string_id: string;
  }
): string {
  const { host, port, city, nickname, string_id, } = params;
  return (
    `[common]

        server_addr = 47.91.90.172
        server_port = 11000

        auto-token = smartway

        [${city} ${nickname} ${string_id}]
        type = tcp
        local_ip = 127.0.0.1
        local_port = 3308
        remote_port = ${port}

        custom_domains = ${host}`
  );
}

/**
 * QOP 隧道在 EFR 子域下的公网域名（只读展示与 EFR 专用 frpc 的 customDomains）。
 * @param stringId - 餐厅码（不含 EFR- 前缀）
 * @returns 形如 EFR-餐厅码.qop.evophotic.it
 */
export function getQopEfrTunnelHost(stringId: string): string {
  const id = (stringId || '').trim();
  return id ? `EFR-${id}.qop.evophotic.it` : '';
}

/**
 * 配置QOP隧道文件
 */
export function getTextTemplateQOP(
  params: {
    string_id: string;
    qop_params: {
      head?: string;
      url?: string;
      port?: string;
    }
  }
): string {
  const { string_id, qop_params } = params;
  return (`serverAddr = "8.209.67.213"
serverPort = 11000
auth.token = "smartway"
[[proxies]]
name = "QOP-${string_id}"
type = "${defaultQopWanConfig({ type: 'protocol', protocol: qop_params.head })}"
localPort = ${defaultQopWanConfig({ type: 'port', port: qop_params.port })}
customDomains = ["${defaultQopWanConfig({ type: 'url', url: qop_params.url, string_id })}"]`)
}

/**
 * 生成 EFR 子域的 QOP frpc 配置内容；协议、本地端口与标准 QOP 配置一致，仅 name 与 customDomains 使用 EFR 域名。
 * @param params.string_id - 餐厅码
 * @param params.qop_params - 与标准 QOP 相同的 head/port（url 不参与 EFR 域名，由餐厅码推导）
 */
export function getTextTemplateQOPEFR(
  params: {
    string_id: string;
    qop_params: {
      head?: string;
      url?: string;
      port?: string;
    };
  }
): string {
  const { string_id, qop_params } = params;
  const efrHost = getQopEfrTunnelHost(string_id);
  return (`serverAddr = "8.209.67.213"
serverPort = 11000
auth.token = "smartway"
[[proxies]]
name = "QOP-EFR-${string_id}"
type = "${defaultQopWanConfig({ type: 'protocol', protocol: qop_params.head })}"
localPort = ${defaultQopWanConfig({ type: 'port', port: qop_params.port })}
customDomains = ["${efrHost}"]`)
}
/**
 * qop wan 默认设置
 */
export function defaultQopWanConfig(params: { type: 'protocol' | 'url' | 'port', string_id?: string, url?: string, protocol?: string, port?: string }): string {
  switch (params.type) {
    case 'protocol':
      return params.protocol || 'http';
    case 'url':
      return params.url || `${params.string_id}.qop.evophotic.it`;
    case 'port':
      return params.port || '80';
    default:
      return '';
  }
}


// $ 判断是手机端还是移动端
export function TestingEquipment(removeDevice?: RegExp): boolean {
  /**
   * 1.检测中断，如果是手机端返回false，电脑的返回true
   */
  const ua = navigator.userAgent.toLowerCase();
  if (/mobile|android|iphone|ipad|phone/i.test(ua)) {
    if (removeDevice && removeDevice.test(ua)) return true;
    return false;
  }
  return true;
}

// $ 判断手机是否为横屏
export function rotate(): boolean {
  if (window.orientation === 180 || window.orientation === 0) {
    // 竖屏
    return false;
  }
  if (window.orientation === 90 || window.orientation === -90) {
    // 横屏
    return true;
  }
  return false;
}

/**
 * 格式化数字
 * @param source 需要格式化的数据
 * @param n 小数位数
 * @param x 几位分割
 * @param s 整数分割符
 * @param c 小数分割符
 */
export function formatNumber(
  source: number,
  n: number,
  x: number,
  s: string,
  c: string,
): string {
  const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
  // ~~ 取整，将非数字字符转为数字
  const num = source.toFixed(Math.max(0, ~~n));
  return (c ? num.replace('.', c) : num).replace(
    new RegExp(re, 'g'),
    '$&' + (s || ','),
  );
}

/**
 * 将价格转为欧元形式
 * @param source 需要格式化的价格
 */
export function formatEUR(source: number = 0): string {
  return `${getCurrencyName()} ` + formatNumber(source, 2, 3, '.', ',');
}

/**
 * 菜品销售数量四舍五入为整数（菜单/类别/菜品销售分析 total_quantity 展示与导出）。
 * @param value - 接口 total_quantity 原始值
 * @returns 整数；非有限数时返回 0
 */
export function roundSalesQuantity(value: number | string | null | undefined): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n);
}

// 获取货币符号
export function getCurrencyName(): string {
  return mainPageData.rbpCurrency || '€';
}


// 将网络图片转为base64
export async function getBase64(url: string): Promise<string> {
  return axios.get(url, { responseType: 'arraybuffer' })
    .then((response) =>
      Buffer.from(response.data, 'binary').toString('base64')
    );
}

/**
 * 国家语义正则
 * @param lng
 */
export function setCoutryLng(lng: string): string {
  // ZH
  const regex_ZH = /zh(-)?/gi;
  // EN
  const regex_EN = /en(-)?/gi;
  // IT
  const regex_IT = /it(-)?/gi;
  // ES
  const regex_ES = /ES(-)?/gi;

  if (regex_ZH.test(lng)) return 'CN';
  if (regex_EN.test(lng)) return 'EN';
  if (regex_IT.test(lng)) return 'IT';
  if (regex_ES.test(lng)) return 'SP';

  return 'EN';
}

export function checkLng(lng: string): string {
  const regexLng = /EN|CN|IT|SP|FR?/gi;
  if (regexLng.test(lng)) return lng;
  return '';
}

/**
 * 获取时区
 * - 只需要欧洲地区
 * - 再加 'Asia/Shanghai'
 */
export function getMomentTimeZone() {
  const newCountryTimeZone: any = [];
  try {
    momentTimeZone.tz.names().forEach((item, index) => {
      if (item.includes('Europe') || item.includes('America')) {
        newCountryTimeZone.push({
          label: item,
          value: item,
          _id: `${Math.random()} -${index} `,
        });
      }
    });
    newCountryTimeZone.push({
      label: 'Asia/Shanghai',
      value: 'Asia/Shanghai',
      _id: '0',
    });
  } catch (error) {
  }
  return newCountryTimeZone;
}

/**
 * 导出表格
 * data: [
 *  [ "id",  "name", "value" ],
 *  [   1,  "sheetjs", 7262  ],
 *  [   2,  "js-xlsx", 6969  ]
 * ]
 * @param data 数据
 * @param fileName  文件名称
 * @param wpx 列宽设置
 */
export function exportExcel(data: string[][], fileName: string, wpx: Array<{ wpx: number }>) {
  /* convert state to workbook */
  const ws = xlsx.utils.aoa_to_sheet(data);
  ws['!cols'] = wpx;
  const wb = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(wb, ws, 'SheetJS');
  /* generate XLSX file and send to client */
  xlsx.writeFile(wb, fileName)
}

/**
 * 导出多个sheet的Excel
 * @param fileName
 * @param sheetData
 * - item.sheetName  Sheet names cannot exceed 31 chars
 */
export function exportMultipleSheetExcel(fileName: string, sheetData: { sheetName?: string, data: string[][], wpx: Array<{ wpx: number }> }[]) {
  const wb = xlsx.utils.book_new();
  /* convert state to workbook */
  sheetData.forEach((item) => {

    const ws = xlsx.utils.aoa_to_sheet(item.data);
    ws['!cols'] = item.wpx;
    if (item?.sheetName && item?.sheetName?.length > 31) {
      delete item.sheetName
    }
    xlsx.utils.book_append_sheet(wb, ws, item.sheetName);
  })
  /* generate XLSX file and send to client */
  xlsx.writeFile(wb, fileName + '.xlsx')
}


/**
 * 将指定国家的 ISO 3166-1 代码转换为 Google Places 兼容的语言代码
 * @param {string} countryCode - 如 'IT', 'CN', 'ES'
 * @returns {string} 语言代码，如 'it'
 */
export function getLanguageByCountry(countryCode: string) {
  // 仅包含你提供的国家列表及其对应的语言代码
  const map = {
    'AL': 'sq', // 阿尔巴尼亚 → 阿尔巴尼亚语
    'AT': 'de', // 奥地利 → 德语
    'CN': 'zh-CN', // 中国 → 中文
    'FR': 'fr', // 法国 → 法语
    'DE': 'de', // 德国 → 德语
    'IT': 'it', // 意大利 → 意大利语
    'LU': 'fr', // 卢森堡 → 法语
    'PT': 'pt', // 葡萄牙 → 葡萄牙语
    'SI': 'sl', // 斯洛文尼亚 → 斯洛文尼亚语
    'ES': 'es',  // 西班牙 → 西班牙语
    'TW': 'zh-TW', // 台湾 → 中文
    'UK': 'en', // 英国 → 英语
    'US': 'en', // 美国 → 英语
    'HK': 'zh-HK', // 香港 → 中文
  };

  return map[countryCode] || 'en'; // 默认返回英语
}


